<template>
  <b-container class="p-main-container">
    <div class="p-buttons-wrap">
      <!-- <b-btn @click="hideModal">Close Me</b-btn> -->
      <b-button variant="info" @click="print">Print Profile</b-button>
      <b-button variant="info" @click="edit">Edit Profile</b-button>

      <!-- <button v-print="'#printMe'">Print Application</button> -->
    </div>
    <div id="printme">
      <div>
        <b-row>
          <b-col cols="8" offset="1">
            <b-container class="bv-example-row">
              <table>
                <tr>
                  <td>
                    <span class="app-bold">Application No:</span>
                    <span class="mr-5">{{personalDetails.LoanApplicationNo}}</span>
                  </td>
                  <td>
                    <span class="app-bold ml-5">Application Date:</span>
                    <span>{{personalDetails.ApplicationDate}}</span>
                  </td>
                </tr>
              </table>
            </b-container>
          </b-col>
        </b-row>
      </div>
      <div class="application-view">
        <div></div>
        <div class="reg-form-box">
          <div class="reg-form-body">
            <b-container class="bv-example-row">
              <b-row>
                <b-col cols="8" offset="1">
                  <b-container class="bv-example-row">
                    <h5 class="reg-form-title text-primary">Personal Details</h5>

                    <!-- <b-row>
                      <b-col>Application No: {{personalDetails.LoanApplication[0].LoanApplicationNo}}</b-col>
                    </b-row>-->

                    <table class="profile-table table-3x">
                      <tbody>
                        <tr>
                          <td>
                            <span class="bold">First Name:</span>
                            {{personalDetails.FirstName}}
                          </td>
                          <td>
                            <span class="bold">Middle Name:</span>
                            {{personalDetails.MiddleName}}
                          </td>
                          <td>
                            <span class="bold">Last Name:</span>
                            {{personalDetails.LastName}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Date Of Birth:</span>
                            {{personalDetails.DOB}}
                          </td>
                          <td>
                            <span class="bold">Aadhar Id:</span>
                            {{personalDetails.AdharNo}}
                          </td>
                          <td>
                            <span class="bold">Mobile No.:</span>
                            {{personalDetails.Mobile}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Email:</span>
                            {{personalDetails.EmailID}}
                          </td>
                          <td>
                            <span class="bold">Gender:</span>
                            <span v-if="personalDetails.Gender">Male</span>
                            <span v-else>Female</span>
                          </td>
                          <td>
                            <span class="bold">Pan Card No.:</span>
                            {{personalDetails.PanCardNo}}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span class="bold">Maharashtra Domicile:</span>
                            <span v-if="personalDetails.Domiciled">Yes</span>
                            <span v-else>No</span>
                          </td>
                          <td>
                            <span class="bold">Ration Card No:</span>
                            {{personalDetails.RationCardNo}}
                          </td>
                          <td>
                            <span class="bold">Total Income:</span>
                            {{personalDetails.FamilyIncome}}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <span class="bold">Caste:</span>
                            {{personalDetails.CasteName}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-container>
                </b-col>

                <!-- <b-col cols="2" offset>
                  <b-container class="bv-example-row">
                    <b-row>
                      <b-col>
                        <img
                          style="width:120px;height:auto"
                          :src="getImgUrl(personalDetails.PhotoPath)"
                        />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <img
                          style="width:120px;height:auto;display:none"
                          :src="getImgUrl(personalDetails.SignaturePath)"
                        />
                      </b-col>
                    </b-row>
                  </b-container>
                </b-col>-->
              </b-row>
            </b-container>
          </div>
        </div>
      </div>

      <!-- *********** -->

      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Address Details</h5>

                  <table class="profile-table table-3x">
                    <tbody>
                      <tr>
                        <td colspan="3">
                          <span class="bold">Address:</span>
                          {{personalDetails.Address}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Taluka:</span>
                          {{personalDetails.TalukaName}}
                        </td>
                        <td>
                          <span class="bold">District:</span>
                          {{personalDetails.DistrictName}}
                        </td>
                        <td>
                          <span class="bold">State:</span>
                          {{personalDetails.StateName}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- ********* -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Bank Account</h5>
                  <table class="profile-table table-3x">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Bank Account No:</span>
                          {{personalDetails.BankAccountNo}}
                        </td>

                        <td>
                          <span class="bold">Bank IFSC Code:</span>
                          {{personalDetails.BankIfscCode}}
                        </td>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{personalDetails.BankName}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Branch Name:</span>
                          {{personalDetails.BranchName}}
                        </td>
                        <td>
                          <span class="bold">City:</span>
                          {{personalDetails.BankCity}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- Group details -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="3"></b-col>
              <b-col cols="9" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Family Details</h5>
                  <table class="profile-table info-table">
                    <tr>
                      <th>Full Name</th>
                      <th>Gender</th>
                      <th>Date of Birth</th>
                      <th>Relation Ship</th>
                    </tr>
                    <tr v-for="member in familyDetails" :key="member.FamilyDetailID">
                      <td>{{member.FullName}}</td>
                      <td v-if="member.Gender">Male</td>
                      <td v-else>Female</td>
                      <td>{{member.DOB}}</td>
                      <td>{{member.RelationshipName}}</td>
                    </tr>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="10" offset="1">
                <b-container class="bv-example-row group-details-container">
                  <h5 class="reg-form-title text-primary">Group Details</h5>
                  <table class="profile-table table-3x">
                    <tbody>
                      <tr>
                        <td colspan="2">
                          <span class="bold">Group Name:</span>
                          {{personalDetails.GroupName}}
                        </td>
                        <td>
                          <span class="bold">Registration No:</span>
                          {{personalDetails.CompanyRegNo}}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="2">
                          <span class="bold">Registerd Address:</span>
                          {{personalDetails.GroupRegisteredAddress}}
                        </td>
                        <td>
                          <span class="bold">Under Disability?</span>
                          <span v-if="personalDetails.IsUnderDisability">Yes</span>
                          <span v-else>No</span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Group PAN:</span>
                          {{personalDetails.GroupPAN}}
                        </td>
                        <td>
                          <span class="bold">Group TAN:</span>
                          {{personalDetails.GroupTAN}}
                        </td>
                        <td>
                          <span class="bold">Company/Group Type:</span>
                          {{personalDetails.EmployerCompanyType}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- Group details ends -->
      <!--Lending Bank Details-->
      <div class="reg-form-box" style>
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="8" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Lending Loan Details</h5>

                  <table class="profile-table" style="margin-left:0">
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">Loan District:</span>
                          {{personalDetails.LoanDistrict}}
                        </td>
                        <td colspan="2">
                          <span class="bold">Business Name:</span>
                          {{personalDetails.BusinessName}}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <span class="bold">Business Address:</span>
                          {{personalDetails.BusinessAddress}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Taluka:</span>
                          {{personalDetails.BusinesTalukaName}}
                        </td>
                        <td>
                          <span class="bold">District:</span>
                          {{personalDetails.BusinessDistrict}}
                        </td>
                        <td>
                          <span class="bold">Product:</span>
                          {{personalDetails.FinalProduct}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Amount From Bank:</span>
                          {{personalDetails.LoanAmount}}
                        </td>
                        <td>
                          <span class="bold">Bank Name:</span>
                          {{personalDetails.LoanBank}}
                        </td>
                        <td>
                          <span class="bold">Branch:</span>
                          {{personalDetails.LoanBranch}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!--Lending Bank Ends-->

      <!-- directors starts -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="10" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Directors</h5>
                  <table
                    class="profile-table table-3x mt-4"
                    v-for="member in directorDetails"
                    :key="member.GroupDirectorID"
                  >
                    <tbody>
                      <tr>
                        <td>
                          <span class="bold">First Name:</span>
                          {{member.DirectorFirstName}}
                        </td>
                        <td>
                          <span class="bold">Middle Name:</span>
                          {{member.DirectorMiddleName}}
                        </td>
                        <td>
                          <span class="bold">Last Name:</span>
                          {{member.DirectorLastName}}
                        </td>
                        <td rowspan="5">
                          <img style="width:100px;height:auto;" :src="getImgUrl(member.PhotoPath)" />
                        </td>
                      </tr>
                      <tr>
                        <td colspan="3">
                          <span class="bold">Address:</span>
                          {{member.DirectorAddress}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Date Of Birth:</span>
                          {{member.DirectorDOB}}
                        </td>
                        <td>
                          <span class="bold">Mobile No.:</span>
                          {{member.DirectorMobile}}
                        </td>
                        <td>
                          <span class="bold">Email:</span>
                          {{member.DirectorEmail}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="bold">Designation:</span>
                          {{member.DirectorDesignation}}
                        </td>
                        <td>
                          <span class="bold">Aadhar Id:</span>
                          {{member.DirectorAadhar}}
                        </td>
                        <!-- <td>
                          <span class="bold">Gender:</span>
                          <span v-if="member.Gender">Male</span>
                          <span v-else>Female</span>
                        </td>-->
                        <td>
                          <span class="bold">Pan Card No.:</span>
                          {{member.DirectorPAN}}
                        </td>
                      </tr>
                      <!-- <tr>
                        
                        <td>
                          <span class="bold">Ration Card No:</span>
                          {{personalDetails.RationCardNo}}
                        </td>
                        <td>
                          <span class="bold">Total Income:</span>
                          {{personalDetails.FamilyIncome}}
                        </td>
                      </tr>-->
                      <tr>
                        <td colspan="3">
                          <span class="bold">Caste:</span>
                          {{member.DirectorCaste}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <table class="profile-table info-table">
                    <tr>
                      <th>First Name</th>
                      <th>Middel Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Designation</th>
                      <th>Aadhar No.</th>
                      <th>Address</th>
                      <th>Mobile No.</th>
                    </tr>
                    <tr v-for="member in personalDetails.GroupDirectors" :key="member">
                      <td>{{member.DirectorFirstName}}</td>
                      <td>{{member.DirectorMiddleName}}</td>
                      <td>{{member.DirectorLastName}}</td>
                      <td>{{member.DirectorEmail}}</td>
                      <td>{{member.DirectorDesignation}}</td>
                      <td>{{member.DirectorAadhar}}</td>
                      <td>{{member.DirectorAddress}}</td>
                      <td>{{member.DirectorMobile}}</td>
                    </tr>
                  </table>-->
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>

      <!-- directors ends -->

      <!-- shareholders details start -->
      <div class="reg-form-box">
        <div class="reg-form-body">
          <b-container class="bv-example-row">
            <b-row>
              <b-col cols="10" offset="1">
                <b-container class="bv-example-row">
                  <h5 class="reg-form-title text-primary">Shareholders Details</h5>
                  <table class="profile-table info-table">
                    <tr>
                      <th>First Name</th>
                      <th>Middle Name</th>
                      <th>Last Name</th>
                      <th>Gender</th>
                      <th>Address</th>
                      <th>DOB</th>
                      <th>Aadhar</th>
                    </tr>
                    <tr v-for="member in shareholderDetails" :key="member">
                      <td>{{member.ShareholderFirstName}}</td>
                      <td>{{member.ShareholderMiddleName}}</td>
                      <td>{{member.ShareHolderLastName}}</td>
                      <td v-if="member.ShareholderGender=='1'">Male</td>
                      <td v-else>Female</td>
                      <td>{{member.ShareholderAddress}}</td>
                      <td>{{member.ShareholderDOB}}</td>
                      <td>{{member.ShareHolderAadhar}}</td>
                    </tr>
                  </table>
                </b-container>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <!-- shareholder details ends -->
    </div>

    <!-- documents -->

    <div class="reg-form-box" style>
      <div class="reg-form-body">
        <b-container class="bv-example-row">
          <b-row>
            <b-col cols="8" offset="1">
              <b-container class="bv-example-row">
                <h5 class="reg-form-title text-primary">Group Documents Uploaded</h5>
                <table class="profile-table doc-table">
                  <tr>
                    <th>Sr No</th>
                    <th>Document Type</th>
                    <th>Value</th>
                    <th>Link</th>
                  </tr>
                  <tr v-if="personalDetails.PhotoPath !=''">
                    <td>00.</td>
                    <td>Photo</td>
                    <td></td>
                    <td>
                      <a target="_blank" :href="getImgUrl(personalDetails.PhotoPath)">View</a>
                    </td>
                  </tr>
                  <tr v-if="personalDetails.RegCopy  !=''">
                    <td>01.</td>
                    <td>Company/Group Registration Certificate</td>
                    <td></td>
                    <td>
                      <span v-if="personalDetails.RegCopy ==''">Not Uploaded</span>
                      <span v-if="personalDetails.RegCopy !=''">
                        <a target="_blank" :href="getImgUrl(personalDetails.RegCopy)">View</a>
                      </span>
                    </td>
                  </tr>

                  <tr v-if="personalDetails.PersonResolutionPath !=''">
                    <td>02.</td>
                    <td>Authorization Resolution</td>
                    <td></td>
                    <td>
                      <span v-if="personalDetails.PersonResolutionPath ==''">Not Uploaded</span>
                      <span v-if="personalDetails.PersonResolutionPath !=''">
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.PersonResolutionPath)"
                        >View</a>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td>03.</td>
                    <td>Adhar Card</td>
                    <td>{{personalDetails.AdharNo}}</td>
                    <td>
                      <span v-if="personalDetails.AddharCardPath ==''">Not Uploaded</span>
                      <span v-if="personalDetails.AddharCardPath !=''">
                        <a target="_blank" :href="getImgUrl(personalDetails.AddharCardPath)">View</a>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td>04.</td>
                    <td>Adhar Card BackSide</td>
                    <td></td>
                    <td>
                      <span v-if="personalDetails.AddharCardBackPath ==''">Not Uploaded</span>
                      <span v-if="personalDetails.AddharCardBackPath !=''">
                        <a
                          target="_blank"
                          :href="getImgUrl(personalDetails.AddharCardBackPath)"
                        >View</a>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>05.</td>
                    <td>Bank Account</td>
                    <td></td>
                    <td>
                      <span v-if="personalDetails.BankAccount ==''">Not Uploaded</span>
                      <span v-if="personalDetails.BankAccount !=''">
                        <a target="_blank" :href="getImgUrl(personalDetails.BankAccount)">View</a>
                      </span>
                    </td>
                  </tr>
                  <tr v-if="(personalDetails.OtherDocument !='' && personalDetails.OtherDocument != null) || (personalDetails.Other1 !='' && personalDetails.Other1 != null)">
                    <td>06.</td>
                    <td>{{personalDetails.OtherName || personalDetails.Other1Name}}</td>
                    <td></td>
                    <td>
                      <a target="_blank" :href="getImgUrl(personalDetails.OtherDocument || personalDetails.Other1)">View</a>
                    </td>
                  </tr>
                  <tr v-if="personalDetails.Other2 !='' && personalDetails.Other2 != null">
                    <td>07.</td>
                    <td>{{personalDetails.Other2Name}}</td>
                    <td></td>
                    <td>
                      <a target="_blank" :href="getImgUrl(personalDetails.Other2)">View</a>
                    </td>
                  </tr>
                  <tr v-if="personalDetails.Other3 !='' && personalDetails.Other3 != null">
                    <td>08.</td>
                    <td>{{personalDetails.Other3Name}}</td>
                    <td></td>
                    <td>
                      <a target="_blank" :href="getImgUrl(personalDetails.Other3)">View</a>
                    </td>
                  </tr>
                  <tr v-if="personalDetails.Other4 !='' && personalDetails.Other4 != null">
                    <td>09.</td>
                    <td>{{personalDetails.Other4Name}}</td>
                    <td></td>
                    <td>
                      <a target="_blank" :href="getImgUrl(personalDetails.Other4)">View</a>
                    </td>
                  </tr>
                </table>
              </b-container>
              <b-container
                class="bv-example-row mt-3"
                v-for="(director, index) in directorDetails"
                :key="index"
              >
                <h5 class="reg-form-title text-primary">Director-{{index+1}} Documents Uploaded</h5>
                <table class="profile-table doc-table" style="margin-left:0">
                  <tr>
                    <th>Sr No</th>
                    <th>Document Type</th>
                    <th>Value</th>
                    <th>Link</th>
                  </tr>
                  <tr>
                    <td>01.</td>
                    <td>Photo</td>
                    <td></td>
                    <td>
                      <span v-if="director.PhotoPath ==''">Not Uploaded</span>
                      <span v-if="director.PhotoPath !=''">
                        <a target="_blank" :href="getImgUrl(director.PhotoPath)">View</a>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td>02.</td>
                    <td>PAN Card</td>
                    <td>{{director.DirectorPAN}}</td>
                    <td>
                      <span v-if="director.PancardPath ==''">Not Uploaded</span>
                      <span v-if="director.PancardPath !=''">
                        <a target="_blank" :href="getImgUrl(director.PancardPath)">View</a>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td>03.</td>
                    <td>Adhar Card</td>
                    <td>{{director.DirectorAadhar}}</td>
                    <td>
                      <span v-if="director.AddharCardPath ==''">Not Uploaded</span>
                      <span v-if="director.AddharCardPath !=''">
                        <a target="_blank" :href="getImgUrl(director.AddharCardPath)">View</a>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td>03.</td>
                    <td>Adhar Card BackSide</td>
                    <td></td>
                    <td>
                      <span v-if="director.AddharCardBackPath ==''">Not Uploaded</span>
                      <span v-if="director.AddharCardBackPath !=''">
                        <a target="_blank" :href="getImgUrl(director.AddharCardBackPath)">View</a>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td>05.</td>
                    <td>CIBIL Score Proof</td>
                    <td>{{director.DirectorCibil}}</td>
                    <td>
                      <span v-if="director.CibilProof ==''">Not Uploaded</span>
                      <span v-if="director.CibilProof !=''">
                        <a target="_blank" :href="getImgUrl(director.CibilProof)">View</a>
                      </span>
                    </td>
                  </tr>

                  <!-- <tr>
                    <td>06.</td>
                    <td>Ration Card Last Page</td>
                    <td>{{personalDetails.RationCardNo}}</td>
                    <td>
                      <span v-if="director.RationCardLastPath ==''">Not Uploaded</span>
                      <span v-if="director.RationCardLastPath !=''">
                        <a target="_blank" :href="getImgUrl(director.RationCardLastPath)">View</a>
                      </span>
                    </td>
                  </tr>-->

                  <tr>
                    <td>06.</td>
                    <td>Caste Certificate</td>
                    <td>{{director.DirectorCaste}}</td>
                    <td>
                      <span v-if="director.CastCertificate ==''">Not Uploaded</span>
                      <span v-if="director.CastCertificate !=''">
                        <a target="_blank" :href="getImgUrl(director.CastCertificate)">View</a>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td>07.</td>
                    <td>Birth Certificate</td>
                    <td>{{director.DirectorDOB}}</td>
                    <td>
                      <span v-if="director.BirthCertificate ==''">Not Uploaded</span>
                      <span v-if="director.BirthCertificate !=''">
                        <a target="_blank" :href="getImgUrl(director.BirthCertificate)">View</a>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td>08.</td>
                    <td>Residance Address</td>
                    <td></td>
                    <td>
                      <span v-if="director.ResidentialProofPath ==''">Not Uploaded</span>
                      <span v-if="director.ResidentialProofPath !=''">
                        <a target="_blank" :href="getImgUrl(director.ResidentialProofPath)">View</a>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>09.</td>
                    <td>Domicile Certificate</td>
                    <td></td>
                    <td>
                      <span v-if="director.DomicileCertificate ==''">Not Uploaded</span>
                      <span v-if="director.DomicileCertificate !=''">
                        <a target="_blank" :href="getImgUrl(director.DomicileCertificate)">View</a>
                      </span>
                    </td>
                  </tr>

                  <tr>
                    <td>10.</td>
                    <td>Income Certificate</td>
                    <td></td>
                    <td>
                      <span v-if="director.IncomeCertificatePath ==''">Not Uploaded</span>
                      <span v-if="director.IncomeCertificatePath !=''">
                        <a target="_blank" :href="getImgUrl(director.IncomeCertificatePath)">View</a>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>11.</td>
                    <td>Bank Account Proof</td>
                    <td>{{personalDetails.BankAccountNo}}</td>
                    <td>
                      <span v-if="director.BankAccount ==''">Not Uploaded</span>
                      <span v-if="director.BankAccount !=''">
                        <a target="_blank" :href="getImgUrl(director.BankAccount)">View</a>
                      </span>
                    </td>
                  </tr>
                  <tr v-if="director.Other1 !=''">
                    <td>12.</td>
                    <td>{{director.Other1Name}}</td>
                    <td></td>
                    <td>
                      <span v-if="director.Other1 ==''">Not Uploaded</span>
                      <span v-if="director.Other1 !=''">
                        <a target="_blank" :href="getImgUrl(director.Other1)">View</a>
                      </span>
                    </td>
                  </tr>
                  <tr v-if="director.Other2 !=''">
                    <td>13.</td>
                    <td>{{director.Other2Name}}</td>
                    <td></td>
                    <td>
                      <span v-if="director.Other2 ==''">Not Uploaded</span>
                      <span v-if="director.Other2 !=''">
                        <a target="_blank" :href="getImgUrl(director.Other2)">View</a>
                      </span>
                    </td>
                  </tr>
                  <tr v-if="director.Other3 !=''">
                    <td>14.</td>
                    <td>{{director.Other3Name}}</td>
                    <td></td>
                    <td>
                      <span v-if="director.Other3 ==''">Not Uploaded</span>
                      <span v-if="director.Other3 !=''">
                        <a target="_blank" :href="getImgUrl(director.Other3)">View</a>
                      </span>
                    </td>
                  </tr>
                  <tr v-if="director.Other4 !=''">
                    <td>15.</td>
                    <td>{{director.Other4Name}}</td>
                    <td></td>
                    <td>
                      <span v-if="director.Other4 ==''">Not Uploaded</span>
                      <span v-if="director.Other4 !=''">
                        <a target="_blank" :href="getImgUrl(director.Other4)">View</a>
                      </span>
                    </td>
                  </tr>
                </table>
              </b-container>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- documenets ends -->
  </b-container>
</template>

<script>
import apis from "@/apis";
import vueHtmlToPaper from "vue-html-to-paper";
import Formatter from "@/Formatter.js";
export default {
  data() {
    return {
      personalDetails: {
        FirstName: "Rhoit",
        MiddleName: "T",
        LastName: "Date",
        FullName: "Rhoit T Date",
        DOB: "01-Feb-1991",
        Age: 30,
        Gender: true,
        MotherName: "Test",
        Mobile: "9856742582",
        EmailID: "rohit@gmail.com",
        AdharNo: "123456789988",
        PanCardNo: "KJUYP0698A",
        Nationality: true,
        Domiciled: true,
        FamilyIncome: 800000,
        RationCardNo: "1234Z",
        CasteName: "5-बजानिया",
        Address: "12, 12, 12, Landmark: vishnunag",
        VillageCity: "thane",
        TalukaName: "Thane",
        DistrictName: "Thane",
        StateName: "Maharashtra-400078",
        dbBankName: "ICICI Bank",
        BranchName: "Nariman Point",
        BankAccountNo: "123456123456",
        BankIfscCode: "ICIC0000001",
        BankCity: "Mumbai",
        LoanApplicationNo: null,
        Loantype: null,
        ApplicationDate: null,
        LoanApplicationStatus: null,
        ApplicationStatus: null,
        MeetingDate: null,
        ApprovalStatus: null,
        ApprovalDoc: null,
        GroupName: "Test",
        GroupRegisteredAddress: "Test Addreess",
        GroupPAN: "BCQPR2596K",
        GroupTAN: "BCQPR2596K",
        CompanyRegNo: "123456",
        EmployerCompanyType: "Government Approved Saving Group",
        IsUnderDisability: false,
        BusinessName: "",
        BusinessAddress: "",
        BusinesTalukaName: "Mumbai City",
        BusinessDistrict: "Mumbai City",
        LoanDistrict: "Mumbai City",
        FinalProduct: "Test",
        LoanAmount: 1234567.0,
        LoanBank: null,
        LoanBranch: null,
        AddharCardPath: "AddharCard_.png",
        AddharCardBackPath: "",
        BankAccount: "BankAccount_.png",
        RegCopy: "RegCopy_.jpg",
        PersonResolutionPath: "ResidentialProof_.jpg",
        Other1: "OtherDocument,_.jpg",
        Other1Name: "",
        Other2: "",
        Other2Name: "",
        Other3: "",
        Other3Name: "",
        Other4: "",
        Other4Name: ""
      },
      directorDetails: [],
      shareholderDetails: [],
      familyDetails: [],
      docObj: {},
      docTbl: []
    };
  },
  methods: {
    print() {
      window.print();
      //this.$htmlToPaper("printme");
    },
    edit() {
      this.$router.push("/LoginProfile");
    },

    getImgUrl(pic) {
      let userinfo = this.$store.getters.loggedUser;
      let userId = userinfo.UserId;
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" + userId + "/" + pic
        );
      }
    }
  },

  mounted() {
    var userinfo = this.$store.getters.loggedUser;
    let promiseU = apis.ReadGroupProfile(userinfo.UserId); //Personal Details

    promiseU
      .then(response => {
        if (response.status == 200) {
          //console.log(response.body);
          this.personalDetails = response.body.Table[0];
          // this.personalDetails.DOB = Formatter.convertDateFormatYMD(
          //   response.body.DOB
          // );
          // for (var i = 0; i < response.body.LoanApplication.length; i++) {
          //   if (response.body.LoanApplication[i].LoanType == 2) {
          //     this.personalDetails.LoanApplication[0].LoanApplicationNo =
          //       response.body.LoanApplication[i].LoanApplicationNo;
          //   }
          // }
          this.familyDetails = response.body.Table1;
          this.directorDetails = response.body.Table2;
          this.shareholderDetails = response.body.Table3;
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.message;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style>
.p-main-container {
  padding-top: 30px;
  background-color: #fff;
  padding-bottom: 30px;
  overflow: hidden;
}

.p-buttons-wrap {
  width: fit-content;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 30px;
}

.p-buttons-wrap button {
  color: #fff;
  background-color: #2e4b90;
  font-size: 13px;
  font-weight: bold;
  border: none;
  padding: 8px 20px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 4px;
}

.p-buttons-wrap button.btn-info:hover,
.p-buttons-wrap button.btn-info:active,
.p-buttons-wrap button.btn-info:visited,
.p-buttons-wrap button.btn-info:focus {
  background-color: #2e4b90 !important;
  color: #fff !important;
  border: none !important;
  outline: none !important;
}

.text-primary {
  font-size: 18px;
  color: #000 !important;
  margin-bottom: 20px;
  font-weight: bold;
}

table.profile-table {
  border: 0px solid #d3d3d3;
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}
table.profile-table td,
table.profile-table th {
  border: 1px solid #d3d3d3;
  padding: 8px 15px;
}

table.table-3x td,
table.table-3x th {
  width: 33%;
}
table.profile-table td span.bold {
  font-weight: bold;
  font-size: 14px;
}

.app-no {
  font-size: 15px;
  color: #000;

  width: fit-content;
  margin: auto;
  margin-bottom: 10px;
}

.app-no .app-bold {
  font-weight: bold;
}

table.profile-table tbody td {
  font-size: 13px;
  color: #000000;
}

table.info-table th {
  font-size: 13px;
}
table.info-table td {
  font-size: 13px;
}

table.doc-table {
  width: 50%;
}

.reg-form-box .reg-form-body {
  border: none;
  padding-top: 10px;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
}

.bv-example-row {
  padding-left: 0;
  padding-right: 0;
}

@media (max-width: 1070px) {
  .group-details-container {
    overflow: scroll;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/RegistrationLoan/ViewGroupDetailsProfile.vue